import React from 'react';
import DatePicker, { registerLocale } from 'react-datepicker';
import PropTypes from 'prop-types';
import { Form } from 'react-bootstrap';
import es from "date-fns/locale/es";
// styles
import 'assets/css/backoffice/components/dateTimePicker.scss'

registerLocale("es", es);

const DateTimePicker = React.forwardRef((props, ref) => {
  const renderMonthContent = (month, shortMonth, longMonth, day) => {
    const fullYear = new Date(day).getFullYear();
    const tooltipText = `Tooltip for month: ${longMonth} ${fullYear}`;

    return <span title={tooltipText}>{longMonth.charAt(0).toUpperCase() + longMonth.slice(1)}</span>;
  };
  return (
    <Form.Group className="mt-2">
      {props.label && (
        <Form.Label className="text-light">
          {props.label}
        </Form.Label>
      )}
      <div className="position-relative">
        <DatePicker
          ref={ref}
          className={props.className}
          selected={props.value ? new Date(props.value) : props.value}
          onChange={(date) => props.onChange(date)}
          dateFormat={props.dateFormat}
          showTimeInput={props.showTimeInput}
          timeInputLabel={props.timeInputLabel}
          showTimeSelect={props.showTimeSelect}
          showYearPicker={props.showYearPicker}
          showMonthYearPicker={props.showMonthYearPicker}
          renderMonthContent={props.showMonthYearPicker && renderMonthContent}
          timeIntervals={props.timeIntervals}
          timeCaption={props.timeCaption}
          placeholderText={props.placeholderText}
          showIcon={props.showIcon}
          icon={props.icon}
          locale='es'
          minDate={props.minDate}
          maxDate={props.maxDate}
          renderCustomHeader={props.renderCustomHeader}
        />
      </div>
    </Form.Group>
  );
});

DateTimePicker.propTypes = {
  className: PropTypes.string,
  dateFormat: PropTypes.string,
  showTimeInput: PropTypes.bool,
  timeInputLabel: PropTypes.string,
  showTimeSelect: PropTypes.bool,
  showYearPicker: PropTypes.bool,
  showMonthYearPicker: PropTypes.bool,
  timeIntervals: PropTypes.number,
  timeCaption: PropTypes.string,
  placeholderText: PropTypes.string,
  showIcon: PropTypes.bool,
  icon: PropTypes.any,
  label: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.any,
  minDate: PropTypes.any,
  maxDate: PropTypes.any,
  renderCustomHeader: PropTypes.func
};

export default DateTimePicker;
